import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, combineLatest, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { GenericConstants } from '../../enums/generic-constants.enum';
import { ApiUserManager } from '../../enums/api-user-manager.enum';
import { BannerNotification, BannerNotificationResponse } from '../../models/notification/banner-notification';

@Injectable({
  providedIn: 'root'
})
export class BannerNotificationService {
  private localNotifications = new BehaviorSubject<BannerNotification[]>([]);

  constructor(private http: HttpClient) { }

  getBannerNotifications(): Observable<BannerNotification[]> {
    const url = environment.baseUrl + ApiUserManager.NOTIFICATION_BANNER;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN) || ''
    });

    // Combine remote notifications with local ones
    return combineLatest([
      this.http.get<BannerNotification[]>(url, { headers }).pipe(
        catchError((error) => {
          console.error('Error fetching remote banners:', error);
          return of([]);
        })
      ),
      this.localNotifications
    ]).pipe(
      map(([remote, local]) => {
        // Ensure we handle non-array responses if any
        const remoteArr = Array.isArray(remote) ? remote : [];
        const localArr = Array.isArray(local) ? local : [];
        return [...remoteArr, ...localArr];
      })
    );
  }

  /**
   * Adds a notification that exists only in the current session (frontend only)
   */
  addLocalNotification(notification: BannerNotification) {
    // Generate a temporary ID if not present
    if (!notification.id) {
      notification.id = 'local_' + Math.random().toString(36).substr(2, 9);
    }
    this.localNotifications.next([...this.localNotifications.value, notification]);
  }

  /**
   * Removes a local notification by ID
   */
  /**
   * Removes all local notifications
   */
  removeLocalNotification(id: string) {
    const filtered = this.localNotifications.value.filter(n => n.id !== id);
    this.localNotifications.next(filtered);
  }

  /**
   * Removes all local notifications
   */
  clearLocalNotifications() {
    this.localNotifications.next([]);
  }
}
